import Icon from '../components/Icon.vue'

Icon.register({
  'table-tennis': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496.2 296.5c-64.1-43.2-149.5-27.9-195.6 34.2l-211.5-211.5 56-56.1c83.9-84.1 220-84.1 303.9 0 63 63.1 78.7 155.6 47.2 233.4zM278.3 376.2c-3.7 12.7-6.3 25.9-6.2 39.7 0 19.5 3.9 38.1 11 55.1-25.7-2.8-50.6-13.6-70.3-33.3l-35.7-35.7-89.3 103.3c-7.5 8.6-20.7 9.1-28.7 1l-53.4-53.5c-8.1-8.1-7.6-21.3 1-28.8l103-89.4-34.5-34.6c-39-39.1-44.6-98.8-17.3-144.1zM416 320c53 0 96 43 96 96s-43 96-96 96-96-43-96-96 43-96 96-96z'
      }
    ]
  }
})
